import Portfolio from "@/components/Portfolio";

const ProjectsPage = () => (
  <main id="main-content" className="bg-[#0a0a0a] pt-24">
    <h1 className="sr-only">Projetos</h1>
    <Portfolio />
  </main>
);

export default ProjectsPage;
